const gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 });
const gbp2 = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 });

/** £1,234 (whole pounds, with a minus sign for losses). */
export const pounds = (n: number): string => gbp.format(Number.isFinite(n) ? Math.round(n) : 0);

/** £1,234.56 */
export const poundsExact = (n: number): string => gbp2.format(Number.isFinite(n) ? n : 0);

export const percent = (n: number, digits = 0): string =>
  `${(Number.isFinite(n) ? n : 0).toFixed(digits)}%`;

/** Whole days between two YYYY-MM-DD dates, or null if either is missing or invalid. */
export function daysBetween(from: string, to: string): number | null {
  if (!from || !to) return null;
  const a = Date.parse(`${from}T00:00:00Z`);
  const b = Date.parse(`${to}T00:00:00Z`);
  if (Number.isNaN(a) || Number.isNaN(b) || b < a) return null;
  return Math.round((b - a) / 86_400_000);
}

export const today = (): string => new Date().toISOString().slice(0, 10);
